import { useCallback } from "react"

import toast from "react-hot-toast"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { Button, Input, Message } from "semantic-ui-react"

import actions from "actions"
import api from "api"
import { useAppDispatch, useAppSelector } from "store"

function ForgottenPassword() {
  const { t } = useTranslation()

  const email = useAppSelector((state) => state.entry.email)
  const loading = useAppSelector((state) => state.entry.loading)
  const organisation = useAppSelector((state) => state.organisations.urlOrganisation)

  const dispatch = useAppDispatch()
  const setLoading = useCallback(
    (l) => {
      dispatch(actions.entry.updateLoading(l))
    },
    [dispatch],
  )
  const setEmail = useCallback(
    (e) => {
      dispatch(actions.entry.updateEmail(e))
    },
    [dispatch],
  )

  const navigate = useNavigate()

  const sendEmail = useCallback(() => {
    setLoading(true)
    api.auth.sendPasswordResetEmail(
      email,
      organisation?._id,
      () => {
        setLoading(false)
        toast(t("entry.forgottenPassword.sent"))
        navigate("/")
      },
      (err) => {
        setLoading(false)
        toast.error(err.message)
      },
    )
  }, [email, organisation, navigate, setLoading, t])

  return (
    <div>
      <h2>{t("entry.forgottenPassword.title")}</h2>
      <p>{t("entry.forgottenPassword.info")}</p>
      <Message warning>
        Please remember to check your spam or junk mail folder if you don’t receive the email in your inbox
      </Message>
      <Input
        fluid
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t("placeholder.email")}
        autoFocus
      />
      <div style={{ marginTop: 30, textAlign: "right" }}>
        <Button basic onClick={() => navigate("..")} content={t("generic.back")} />
        <Button primary content={t("entry.forgottenPassword.send")} onClick={sendEmail} loading={loading} />
      </div>
    </div>
  )
}

export default ForgottenPassword
